<template>
  <div v-if="suggestedUse" class="how-to-use border-b border-gray-200 lg:p-12 lg:pr-0 md:p-12 md:pr-0 px-6 py-5">
    <div class="border-b border-gray-300 pb-[1.07rem]">
      <Heading 
        :level="4" 
        color="text-ash-200"
      >
        How to Use
      </Heading> 
    </div>
    <p v-if="isHtml" v-html="innerHtmlContent" class="pt-[1.07rem] text-base text-ash-100 leading-relaxed"></p>
    <p v-else class="pt-[1.07rem] text-base text-ash-100 leading-relaxed">{{ suggestedUse }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Heading from '../../../atom/heading.vue'

const { suggestedUse } = defineProps<{ suggestedUse: string }>()
const isHtml = computed(() => /<\/?[a-z][\s\S]*>/i.test(suggestedUse))
const innerHtmlContent = computed(() => {
  if (!isHtml.value) return suggestedUse
  return suggestedUse.replaceAll(/(^<p>)|(<\/p>$)/gi, '')
})
</script>
